export const getChecklistQuestions = (response) => {
  const responseBody = response?.data ?? response;
  const payload = responseBody?.data ?? responseBody;

  if (Array.isArray(payload)) {
    if (payload.some((item) => Array.isArray(item?.questions))) {
      return payload.flatMap((group) =>
        (group.questions || [])
          .filter((question) => question.isActive !== false)
          .map((question) => ({
            ...question,
            stage: question.stage || group.stage,
            role: question.role || group.role,
          })),
      );
    }

    return payload.filter((question) => question.isActive !== false);
  }

  if (Array.isArray(payload?.questions)) {
    return payload.questions.filter((question) => question.isActive !== false);
  }

  if (Array.isArray(payload?.categories)) {
    return payload.categories.flatMap((category) =>
      (category.questions || category.items || [])
        .filter((question) => question.isActive !== false)
        .map((question) => ({
          ...question,
          category: question.category || category.category || category.name,
        })),
    );
  }

  return [];
};

export const getQuestionsMissingNoComments = (questions, answers) =>
  questions.filter((question) => {
    const answer = answers[question.questionId] || {};
    return answer.answer === "No" && !answer.comment?.trim();
  });

export const getChecklistQuestionId = (question, index = 0) =>
  question.questionId ??
  question.id ??
  [question.stage, question.role, question.slNo ?? index]
    .filter((value) => value !== undefined && value !== null && value !== "")
    .join("|");

const getChecklistStageLabel = (stage) => {
  const normalizedStage = String(stage || "").trim().toLowerCase();

  if (normalizedStage.includes("preparation & completeness")) {
    return "Completeness";
  }

  if (
    normalizedStage.includes("analyser & memo") ||
    normalizedStage.includes("analyzer & memo")
  ) {
    return "Analyser";
  }

  return String(stage || "Checklist").trim();
};

export const groupChecklistQuestions = (questions) => {
  const groups = new Map();

  questions.forEach((question) => {
    const stage = question.stage || "";
    const role = question.role || "";
    const key = `${stage}|${role}`;

    if (!groups.has(key)) {
      const stageLabel = getChecklistStageLabel(stage);
      groups.set(key, {
        key,
        title: role ? `${stageLabel} - ${role}` : stageLabel,
        questions: [],
      });
    }

    groups.get(key).questions.push(question);
  });

  return Array.from(groups.values());
};
